import { api } from "./api";

export const PLACE_KEY = "f2j_place";
export const DEFAULT_RADIUS_KM = 25;

export function savedPlace() {
  try {
    const raw = localStorage.getItem(PLACE_KEY);
    const p = raw ? JSON.parse(raw) : null;
    return p && p.concelho ? p : null;
  } catch (err) {
    // localStorage indisponível ou JSON corrompido — retorna null para o fluxo padrão
    console.warn("[nearby] savedPlace falhou:", err?.message || err);
    return null;
  }
}

export function savePlace(place) {
  try {
    localStorage.setItem(PLACE_KEY, JSON.stringify(place));
  } catch (err) {
    // Sem localStorage (modo privado): a localização não fica memorizada
    console.warn("[nearby] savePlace falhou:", err?.message || err);
  }
}

export function clearPlace() {
  try {
    localStorage.removeItem(PLACE_KEY);
  } catch (err) {
    console.warn("[nearby] clearPlace falhou:", err?.message || err);
  }
}

/** Pede a localização ao browser e converte-a no concelho mais próximo. */
export async function detectPlace() {
  if (!navigator.geolocation) {
    throw new Error("O teu browser não permite partilhar a localização.");
  }
  if (typeof window !== "undefined" && window.isSecureContext === false) {
    throw new Error("A localização só funciona em ligações seguras (https).");
  }
  const position = await new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(resolve, (err) => {
      reject(
        new Error(
          err?.code === 1
            ? "Permissão de localização recusada. Podes escrever o teu concelho na pesquisa."
            : "Não conseguimos obter a tua localização. Tenta outra vez."
        )
      );
    }, { enableHighAccuracy: true, timeout: 15000, maximumAge: 120000 });
  });
  const { data } = await api.get("/locations/nearest", {
    params: { lat: position.coords.latitude, lon: position.coords.longitude },
  });
  if (data && data.distance_km > 60) {
    throw new Error("Parece que estás fora de Portugal — escolhe o concelho manualmente.");
  }
  savePlace({ ...data, source: "gps" });
  return { ...data, source: "gps" };
}

export function nearJobsParams(place, radiusKm = DEFAULT_RADIUS_KM) {
  return {
    near_district: place.district,
    near_concelho: place.concelho,
    radius_km: radiusKm,
  };
}

export function nearJobsUrl(place, radiusKm = DEFAULT_RADIUS_KM) {
  const p = new URLSearchParams(nearJobsParams(place, radiusKm));
  return `/empregos?${p.toString()}`;
}
